import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description Defines a video range using startOffset, endOffset, duration.
 * @namespace TimelinePosition
 * @memberOf Qualifiers
 */

/**
 * TimelinePosition
 * @memberOf Qualifiers.TimelinePosition
 */

var TimelinePosition = /*#__PURE__*/function (_Action) {
  _inherits(TimelinePosition, _Action);

  var _super = _createSuper(TimelinePosition);

  function TimelinePosition() {
    var _this;

    _classCallCheck(this, TimelinePosition);

    _this = _super.call(this);
    _this._actionModel = {};
    return _this;
  }
  /**
   * @param {string | number} startOffset
   */


  _createClass(TimelinePosition, [{
    key: "startOffset",
    value: function startOffset(_startOffset) {
      var startOffsetQualifier = new Qualifier('so', _startOffset);
      this.addQualifier(startOffsetQualifier);
      this._actionModel.startOffset = startOffsetQualifier.qualifierValue.toString();
      return this;
    }
    /**
     * @param {string | number} endOffset
     */

  }, {
    key: "endOffset",
    value: function endOffset(_endOffset) {
      var endOffsetQualifier = new Qualifier('eo', _endOffset);
      this.addQualifier(endOffsetQualifier);
      this._actionModel.endOffset = endOffsetQualifier.qualifierValue.toString();
      return this;
    }
    /**
     * @param {string | number} duration
     */

  }, {
    key: "duration",
    value: function duration(_duration) {
      var durationQualifier = new Qualifier('du', _duration);
      this.addQualifier(durationQualifier);
      this._actionModel.duration = durationQualifier.qualifierValue.toString();
      return this;
    }
  }]);

  return TimelinePosition;
}(Action);

export { TimelinePosition };